import { OrderSelectionColumns } from './order-selection-columns';
import { TextKeys } from '../../i18n/text-keys';
import { TableColumn } from '../../models/table-column';
import {OrderFilterModel} from '../../models/order/order-filter.model';

export const getTableColumns = (): TableColumn[] => [
  {
    name: OrderSelectionColumns.Number,
    position: 0,
    selected: true,
    text: TextKeys.order.numberShort,
  },
  {
    name: OrderSelectionColumns.Name,
    position: 1,
    selected: true,
    text: TextKeys.general.name,
  },
  {
    name: OrderSelectionColumns.Description,
    position: 2,
    selected: true,
    text: TextKeys.order.description,
  },
  {
    name: OrderSelectionColumns.CustomerNumber,
    position: 3,
    selected: true,
    text: TextKeys.customer.numberLong,
  },
  {
    name: OrderSelectionColumns.CustomerName,
    position: 4,
    selected: true,
    text: TextKeys.customer.title,
  },
];

export const getOrderFilterOptions = (): OrderFilterModel => ({
  orderNumber: {
    name: TextKeys.order.numberLong,
    selected: false,
  },
  orderName: {
    name: TextKeys.order.name,
    selected: false,
  },
  orderDescription: {
    name: TextKeys.order.description,
    selected: false,
  },
  customerName: {
    name: TextKeys.customer.title,
    selected: false,
  },
  customerNumber: {
    name: TextKeys.customer.numberLong,
    selected: false,
  },
});
